import { useEffect, useState } from "react";
import { getHistory } from "services/citizen";

/**
 * useCitizenHistory
 * Fetches social service histories for the provided citizenId.
 */
const useCitizenHistory = citizenId => {
  const [histories, setHistories] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (!citizenId) {
      setHistories(null);
      return;
    }

    setIsLoading(true);
    setError(null);
    getHistory(citizenId)
      .then(response => {
        if (!isMounted) return;
        const results = response?.results ?? [];
        setHistories(results);
      })
      .catch(err => {
        if (!isMounted) return;
        setError(err);
      })
      .finally(() => {
        if (!isMounted) return;
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [citizenId]);

  return { histories, isLoading, error };
};

export default useCitizenHistory;


